"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getTooltipUtilityClass = getTooltipUtilityClass;

var _utils = require("@mui/utils");

var _generateUtilityClass = _interopRequireDefault(require("../generateUtilityClass"));

function getTooltipUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiTooltip', slot);
}

const tooltipClasses = (0, _utils.unstable_generateUtilityClasses)('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
var _default = tooltipClasses;
exports.default = _default;